import { render, staticRenderFns } from "./Characteristics.vue?vue&type=template&id=0a066c7e&scoped=true&lang=pug&"
import script from "./Characteristics.vue?vue&type=script&lang=js&"
export * from "./Characteristics.vue?vue&type=script&lang=js&"
import style0 from "./Characteristics.vue?vue&type=style&index=0&id=0a066c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a066c7e",
  null
  
)

export default component.exports